import { styled } from "@mui/material";
import { theme } from "../../../../theme";
import { Link } from "react-router-dom";
import { getThemePath } from "../../../../hooks/useGetThemePath";

const colors = theme[getThemePath()].colors;

export const VbgTitle = styled("p")`
  margin: 42.4px 4px 17px 16px;
  font-family: Inter;
  font-size: 2rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.textPrimary.heading};

  @media (max-width: 720px) {
    font-size: 20px;
    margin: 24px 0px 0px 0px;
  }
`;

export const Location = styled("div")`
  width: 24px;
  height: 24px;
  color: ${colors.links.teal};
`;

export const VbgInfo = styled("div")`
  height: 28px;
  flex-grow: 0;
  margin-left: 16px;

  @media (max-width: 720px) {
    margin-left: 0px;
  }
`;

export const StreetInfo = styled("span")`
  width: 128px;
  height: 25px;
  flex-grow: 0;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: left;
  margin-top: 4px;
  color: ${colors.textPrimary.heading};

  @media (max-width: 720px) {
    font-size: 12px;
    margin-top: 8px;
  }
`;

export const Switch = styled("span")`
  width: 24px;
  height: 24px;
  flex-grow: 0;
  margin: 0 0 3px 8px;
  object-fit: contain;
`;

export const Router = styled("span")`
  width: 24px;
  height: 24px;
  color: ${colors.icons.default.fillColor};
`;

export const Hardware = styled("div")`
  margin-top: 6px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.textPrimary.heading};
`;

export const MyService = styled("span")`
  margin: 0 0 24px;
  font-family: Inter;
  font-size: 1.25rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.textPrimary.heading};
  float: left;
`;

export const ViewMyService = styled(Link)`
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${colors.textPrimary.heading};
  font-family: Inter;
  text-decoration: none;
  float: right;
  cursor: pointer;
  border: 1px solid #d0d5dd;
  background: #ffffff;

  padding: 2px 14px;
  border-radius: 4px;

  box-shadow: 0px 1px 2px 0px #1018280d;
`;

export const MyServiceRow = styled("div")`
  margin-top: 40px;
`;
